export { default as OtherActions } from './OtherActions';
export { default as StudentInfo } from './StudentInfo';
export { default as StudentImage } from './StudentImage';
